module.exports = __webpack_public_path__ + "static/media/app-store-badge.d0558d91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Download/images/app-store-badge.svg
// module id = 111
// module chunks = 0